import { useState } from "react";
import { API_URL } from "../../../utils/common";

export interface UpdatePermisoRequest {
    id: number;
    nombre: string;
    descripcion: string;
    sufijo: string;
}

export const useUpdateUsuarioPermiso = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const getToken = () => localStorage.getItem("jwt");

    const actualizarPermiso = async (
        payload: UpdatePermisoRequest
    ): Promise<boolean> => {

        setLoading(true);
        setError(null);

        try {

            const token = getToken();

            if (!token) {
                throw new Error("Token no encontrado");
            }

            const response = await fetch(
                `${API_URL}/cms/admin/permisos/${payload.id}`,
                {
                    method: "PUT",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        nombre: payload.nombre,
                        descripcion: payload.descripcion,
                        sufijo: payload.sufijo,
                    }),
                }
            );

            if (!response.ok) {

                const data = await response.json().catch(() => null);

                throw new Error(
                    data?.message ??
                    "Error al actualizar el permiso"
                );

            }

            return true;

        } catch (err: any) {

            console.error(err);

            setError(
                err.message || "Ocurrió un error"
            );

            return false;

        } finally {

            setLoading(false);

        }

    };

    return {

        actualizarPermiso,
        loading,
        error,

    };

};